export enum Role {
  SUPER_ADMIN = 1,
  REGIONAL_ADMIN = 2,
  AUTHORIZED_DEALER_DISTRIBUTOR = 3,
  FIELD_SERVICE_ENGINEER = 4,
  CUSTOMER_EXTERNAL_ADMIN = 5,
  CYBER_AUTHORIZED_PERSONAL = 6,
  BIO_MEDICAL_ENGINEER = 7,
  GLOBAL_SERVICE_ENGINEER = 8
}

export const Roles: Record<Role, string> = {
  [Role.SUPER_ADMIN]: "Super Admin",
  [Role.REGIONAL_ADMIN]: "Admin - Regional TAC",
  [Role.AUTHORIZED_DEALER_DISTRIBUTOR]: "Authorized Dealers/Distributor",
  [Role.FIELD_SERVICE_ENGINEER]: "Field Service Engineer",
  [Role.CUSTOMER_EXTERNAL_ADMIN]: "Customer External Admin",
  [Role.CYBER_AUTHORIZED_PERSONAL]: "Cyber Authorized personnel",
  [Role.BIO_MEDICAL_ENGINEER]: "BioMedical Engineer",
  [Role.GLOBAL_SERVICE_ENGINEER]: "Global Service engineer",
};

export const DisplayRoles: Record<Role, string> = {
  [Role.SUPER_ADMIN]: "Super Admin",
  [Role.REGIONAL_ADMIN]: "Admin - Regional TAC",
  [Role.AUTHORIZED_DEALER_DISTRIBUTOR]: "Authorized Dealers/Distributor",
  [Role.FIELD_SERVICE_ENGINEER]: "Field Service Engineer",
  [Role.CUSTOMER_EXTERNAL_ADMIN]: "Customer External Admin",
  [Role.CYBER_AUTHORIZED_PERSONAL]: "Cyber Authorized Personnel",
  [Role.BIO_MEDICAL_ENGINEER]: "BioMedical Engineer",
  [Role.GLOBAL_SERVICE_ENGINEER]: "Global Service Engineer",
};
